import React from 'react';
import { useHistory } from 'react-router-dom';
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Button,
    Typography,
    Box,
    makeStyles,
} from '@material-ui/core';
import WarningIcon from '@material-ui/icons/Warning';
import WhatsAppIcon from '@material-ui/icons/WhatsApp';
import LaunchIcon from '@material-ui/icons/Launch';

const useStyles = makeStyles((theme) => ({
    paper: {
        borderRadius: 16,
        padding: theme.spacing(2),
    },
    title: {
        display: 'flex',
        alignItems: 'center',
        gap: theme.spacing(1),
        color: theme.palette.warning.main,
        fontWeight: 'bold',
    },
    icon: {
        fontSize: '2.5rem',
    },
    actionButton: {
        borderRadius: 8,
        fontWeight: 'bold',
        padding: theme.spacing(1, 4),
        boxShadow: '0 4px 12px rgba(0,0,0,0.1)',
    },
    whatsappButton: {
        backgroundColor: '#25D366',
        color: '#FFF',
        '&:hover': {
            backgroundColor: '#128C7E',
        },
    }
}));

const PlanUpgradeModal = ({ open, onClose }) => {
    const classes = useStyles();
    const history = useHistory();

    const handlePanelRedirect = () => {
        history.push('/home/gestao/empresa');
        if (onClose) onClose();
    };

    const handleWhatsAppRedirect = () => {
        window.open('https://api.whatsapp.com/send/?phone=5538998588893&text=Olá, gostaria de falar sobre o upgrade do meu plano', '_blank');
    };

    return (
        <Dialog
            open={open}
            onClose={onClose}
            maxWidth="sm"
            fullWidth
            PaperProps={{ className: classes.paper }}
        >
            <DialogTitle>
                <Box className={classes.title}>
                    <WarningIcon className={classes.icon} />
                    <Typography variant="h5" component="span" style={{ fontWeight: 'bold' }}>
                        Plano Insuficiente
                    </Typography>
                </Box>
            </DialogTitle>
            <DialogContent>
                <Box mb={3}>
                    <Typography variant="body1" gutterBottom style={{ fontWeight: 500 }}>
                        Sentimos muito, mas o seu plano atual não possui acesso a esta funcionalidade.
                    </Typography>

                    <Box mt={2} p={2} bgcolor="#fffaf0" borderRadius={8} border="1px solid #feebc8">
                        <Typography variant="body2" color="textPrimary">
                            Para continuar e liberar este recurso, você precisa realizar o upgrade do seu plano.
                            Escolha uma das opções abaixo para prosseguir:
                        </Typography>
                    </Box>

                    <Box mt={3}>
                        <Typography variant="body2" color="textSecondary">
                            Você pode gerenciar seu plano e add-ons diretamente nas Configurações da Empresa ou falar com um de nossos consultores via WhatsApp.
                        </Typography>
                    </Box>
                </Box>
            </DialogContent>
            <DialogActions style={{ padding: '16px 24px', justifyContent: 'space-between' }}>
                <Button onClick={onClose} color="default">
                    AGORA NÃO
                </Button>
                <Box display="flex" gap={1}>
                    <Button
                        onClick={handleWhatsAppRedirect}
                        variant="contained"
                        className={`${classes.actionButton} ${classes.whatsappButton}`}
                        startIcon={<WhatsAppIcon />}
                    >
                        WHATSAPP
                    </Button>
                    <Button
                        onClick={handlePanelRedirect}
                        variant="contained"
                        color="primary"
                        className={classes.actionButton}
                        startIcon={<LaunchIcon />}
                    >
                        VER PLANOS
                    </Button>
                </Box>
            </DialogActions>
        </Dialog>
    );
};

export default PlanUpgradeModal;
